import { configs } from "./config";
export const BASE_URL = configs?.base_url;
export const PROD_URL = configs?.prod_url;
export const PCMS_URL = configs?.pcms_url;
